import React from 'react';
import {useTranslation} from 'react-i18next';

const Input = (props) => {
    let inputHtml = null;
    let inputClasses = props.inputClasses ? ['input-field', `input-field--${props.inputClasses}`] : ['input-field'];
    const {t, i18n} = useTranslation();

    switch (props.elementtype) {
        case ('textarea'):
            inputHtml =
                <textarea className="_max" {...props.elementconfigs} value={props.value} onChange={props.changed}/>
            break;
        case ('select'):
            inputHtml = (
                <select className="_max" {...props.elementconfigs} value={props.value} onChange={props.changed}>
                    {props.elementconfigs.options.map(option => (
                        <option value={option.value} key={props.id + '-' + option.value}>
                            {option.label}
                        </option>
                    ))}
                </select>
            )
            break;
        case ('radio'):
            inputHtml = (
                <ul>
                    {props.elementconfigs.options.map(option => (
                        <li key={props.elementconfigs.id + '-' + option.value}>
                            <input type="radio"
                                   id={option.value}
                                   name={props.elementconfigs.name}
                                   value={option.value}
                                   onChange={props.changed}
                                   checked={option.value == props.value ? 'checked' : ''}
                            />
							{option.innerHtml ?
								<label htmlFor={option.value} dangerouslySetInnerHTML={{ __html: t(option.innerHtml) }} />
							: <label htmlFor={option.value}>{t(option.label)}</label>}
                        </li>
                    ))}
                </ul>
            )
            break;
        case ('checkbox'):
            inputHtml = (
                <ul>
                    {Object.entries(props.elementconfigs.options).map(item => {
                        const key = item[0];
                        const option = item[1];

                        return (
                            <li key={props.elementconfigs.id + '-' + option.value}>
                                <label className="checkbox-field checkbox-field--gray mb-3 pl-1 mt-2" htmlFor={option.value}>
                                    <input type="checkbox"
                                           key={option.name + `-` + key + '-' + option.selected}
                                           id={option.value}
                                           name={props.elementconfigs.name}
                                           value={option.value}
                                           onChange={props.changed}
                                           checked={option.selected}
                                    />
                                    <span></span>
                                    <strong>&nbsp;{t(option.label)}</strong>
                                </label>
                            </li>
                        )
                    })}
                </ul>
            )
            break;
        case ('input'):
        default:
            inputHtml = <input className="_max" {...props.elementconfigs} value={props.value} onChange={props.changed} placeholder={t(props.placeholder)}/>
            break;
    }

    if (!props.valid && props.shouldValidate && props.touched) {
        inputClasses.push('input-field--error');
    }
    if(props.helper){
        inputClasses.push('input-field--withhelper');
    }

    let validationError = null;
    if (!props.valid && props.touched) {
        validationError = <p className="error">{t(props.errorMessage)}</p>;
    }

    return (<label className={inputClasses.join(' ')} htmlFor={props.id}>



        {props.helper ? <div className="d-flex justify-content-between">
            {(props.label && props.elementconfigs.type != 'hidden' ? <strong>{t(props.label)}</strong> : '')}
            {props.helper}
        </div> : <>
            {(props.label && props.elementconfigs.type != 'hidden' ? <strong>{t(props.label)}</strong> : '')}
            {(props.label ? <br /> : '')}
        </> }

        {inputHtml}
		{props.elementconfigs.inputInfos ?
			<small>{t(props.elementconfigs.inputInfos)}</small>
			:null}
        {validationError}
    </label>);

};

export default Input;
